angular.module('pe4h').controller('Proposal', function ($scope, $rootScope, $http, configuration, $state, $uibModal, $window, $uibModalStack) {

  var actionFunctions = {
    "send-invoice": openSendInvoiceModalWithMessage,
    "resend-invoice": openResendInvoiceWithMessage,
    "send-revised-invoice": openSendRevisedInvoiceModalWithMessage,
    "request-release-of-funds": openRequestReleaseOfFundsModal,
    "re-request-release-of-funds": openRequestReleaseOfFundsModal,
    "complete-escrow-setup": openEscrowVerificationWindow,
    "select-disbursement-method": openSelectDisbursementMethodPage,
  };

  var statusConditions = {
    "complete-escrow-setup": userIsNotVerified
  }

  $scope.status_to_hire_contact_info_to_client = configuration.status_to_hide_contact_info_to["client"];

  $scope.initProposals = function () {
    $http({
      url: configuration.webApi.proposals.proposals,
      method: "GET",
      data: {},
    }).success(function (res, status, headers, config) {
      $scope.proposalsAll = res;
      $scope.proposals = res;
      $scope.paging.total = $scope.proposalsAll.length;
      $scope.createPaginationList();
      addStatusLabel();
      if ($state.params.uid) {
        var currentProposal = $scope.proposals.find(function (proposal) {
          return proposal.Project.UID == $state.params.uid;
        });
        var actionFromStatus = currentProposal && configuration.status_action.proposal[currentProposal.Status];
        if (currentProposal && actionFromStatus) {
          var actionId = actionFromStatus['action_id'];
          var actionFunction = actionFunctions[actionId];
          if (actionFunction) {
            actionFunction(currentProposal.Id, actionId, currentProposal.ProjectId);
          }
        }
      }
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      //authFactory.logout();
    });
  };

  $scope.generateSeoUrlForProposal = function (proposal) {
    var seoTitle = "contract " + proposal.license.Label + " job in " + proposal.Project.City;
    return seoTitle.toLowerCase().replace(/ /g, "-");
  }

  $scope.$watch('paging.mode', function (newValue, oldValue) {
    $scope.createPaginationList();
  });

  $scope.createPaginationList = function () {
    var pageCount = Math.ceil($scope.paging.total / $scope.paging.mode);
    $scope.proposalsPaginated = [];
    $scope.proposals = [];
    for (var i = 0; i < pageCount; i++) {
      var values = $scope.proposalsAll.slice($scope.paging.mode * i, $scope.paging.mode * i + $scope.paging.mode);
      $scope.proposalsPaginated[i] = values;
    };
    $scope.goToPage(1);
  };

  $scope.goToPage = function (page) {
    $scope.paging.current = page;
    if (1 <= page && page <= $scope.proposalsPaginated.length) {
      $scope.proposals = $scope.proposalsPaginated[page - 1];
    }
    addStatusLabel();
    $scope.goToTop();
  };

  var addStatusLabel = function () {
    for (i in $scope.proposals) {
      $scope.proposals[i].status = $scope.proposalStatesDict[$scope.proposals[i].Status];
      $scope.proposals[i].license = $scope.licensesDict[$scope.proposals[i].Project.LicenseId];
    }
  }

  $scope.hire = function () {
    var modalHire = $uibModal.open({
      templateUrl: 'modal-hire.html',
      size: 'sm',
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", function ($scope, $uibModalInstance, $q, $state) {
        $scope.name = $scope.profileData.user.FullName;
        $scope.agreed = function () {
          $http({
            url: configuration.webApi.proposals.id_hire({
              id: $scope.proposal.Id
            }),
            method: "POST",
            data: {},
          }).success(function (res, status, headers, config) {
            $state.reload();
          }).error(function (error, status, headers, config) {
            $scope.alertErrorFromServer(error);
          });
          $uibModalInstance.close();
        }
      }]
    });
    modalHire.closed.then(function (data) {
    });
  }

  var addUserNameMessages = function () {
    for (i in $scope.messages) {
      if ($scope.messages[i].UserId == $scope.user.Id) {
        $scope.messages[i].name = $scope.user.FullName;
        $scope.messages[i].pictureUrl = $scope.user.Picture ? $scope.user.Picture.Url : undefined;
      } else {
        $scope.messages[i].name = $scope.profileData.user.FullName;
        $scope.messages[i].pictureUrl = $scope.profileData.user.Picture ? $scope.profileData.user.Picture.Url : undefined;
      }
    }
  }

  $scope.initProposal = function () {
    $http({
      url: configuration.webApi.proposals.proposals_id({
        id: $state.params.proposalId
      }),
      method: "GET",
      data: {},
    }).success(function (res, status, headers, config) {
      $scope.proposal = res;

      $http({
        url: configuration.webApi.proposals.proposals_id_professional({
          id: $state.params.proposalId
        }),
        method: "GET",
        data: {},
      }).success(function (res, status, headers, config) {
        $scope.profileData.user = res;
        $http({
          url: configuration.webApi.projects.projects_uid({
            uid: $state.params.uid
          }),
          method: "GET",
          data: {},
        }).success(function (res, status, headers, config) {
          $scope.project = res;
          $scope.getMessages();
        }).error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          //authFactory.logout();
        });
        //console.log(res);
      }).error(function (error, status, headers, config) {
        $scope.alertErrorFromServer(error);
        //authFactory.logout();
      });
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      //authFactory.logout();
    });
  };

  //to display them grouped on profile
  var groupLicenses = function () {
    $scope.groupedLicenses = {};
    for (i in $scope.professionalLicenses) {
      if ($scope.groupedLicenses[$scope.professionalLicenses[i].type.Id])
        $scope.groupedLicenses[$scope.professionalLicenses[i].type.Id].states.push($scope.professionalLicenses[i].state.Code);
      else
        $scope.groupedLicenses[$scope.professionalLicenses[i].type.Id] = {
          states: [$scope.professionalLicenses[i].state.Code],
          label: $scope.professionalLicenses[i].type.Label
        };

    }
    //console.log($scope.groupedLicenses);
  }

  var loadLicenses = function (data) {
    $scope.professionalLicenses = [];
    for (i in data) {
      var w = data[i];
      $scope.professionalLicenses.push({
        type: $scope.getLicenseFromId(w.LicenseId),
        state: $scope.getStateFromCode(w.State),
        expires: moment(w.Expires).toDate(),
        popup: {
          opened: false
        }
      });

    }
    groupLicenses();


  }

  $scope.loadLicenses = function (userId) {
    $http({
      url: configuration.webApi.users.licenses({
        id: $scope.profileData.user.Id
      }),
      method: "GET",
      data: {},
    }).success(function (res, status, headers, config) {
      loadLicenses(res);
      //console.log(res);
      //console.log($scope.professionalLicenses);
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      //authFactory.logout();
    });
  }

  $scope.getMessages = function () {
    $http({
      url: configuration.webApi.proposals.proposals_id_message({
        id: $scope.proposal.Id
      }),
      method: "GET",
      data: {},
    }).success(function (res, status, headers, config) {
      $scope.messages = res;
      addUserNameMessages();
      $scope.loadLicenses();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
    });
  }

  function userIsNotVerified(){
    return $scope.user.EscrowVerification === "not_verified";
  }

  $scope.existsStatus = function (proposalStatus) {
    var exists = typeof configuration.status_action.proposal[proposalStatus] !== 'undefined';
    return exists;
  }

  $scope.getStatusAction = function (proposalStatus) {
    if ($scope.existsStatus(proposalStatus))
      return configuration.status_action.proposal[proposalStatus].action_name;
    else
      return 'Action Not Available';
  }

  $scope.showStatusAction = function(proposalStatus) {
    if(!$scope.existsStatus(proposalStatus))
      return false;
    
    var statusActionId = configuration.status_action.proposal[proposalStatus].action_id;
    var checkStatusCondition = statusConditions[statusActionId];
    var conditionsTrue = !checkStatusCondition || checkStatusCondition();
    return conditionsTrue;

  }

  function openSelectDisbursementMethodPage(proposalId, actionId){
    $http({
      url: configuration.webApi.escrowTransactions.getByProposalId({
        proposalId
      }),
      method: "GET"
    }).success(function (res, status, headers, config) {
      var transactionId = res.TransactionId;
      var url = configuration.escrowDisbursementMethodURL({ transactionId });
      window.open(url, "_self");
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('proposals', {uid: null});
      });
    });
  }

  function openEscrowVerificationWindow(proposalId, actionId){
    $http({
      url: configuration.webApi.users.getVerificationLink({
        id: $scope.user.Id
      }),
      method: "GET"
    }).success(function (res, status, headers, config) {
      window.open(res, "_self");
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $window.location.href = '/my-projects';
      });
    });
  }

  function openInvoiceSentModal(action) {
    var modalInvoiceSent = $uibModal.open({
      templateUrl: 'modal-' + action + '-ok.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, $q, $state) {
        if (action == 'send-invoice'){
          $scope.sentInvoiceMessage = $scope.getMessagesParagraphs("sentInvoiceMessage");
        }
        else if (action == 'resend-invoice'){
          $scope.sentInvoiceMessage = $scope.getMessagesParagraphs("resentInvoiceMessage");
        }
        else if (action == 'send-revised-invoice'){
          $scope.sentRevisedInvoiceMessage = $scope.getMessagesParagraphs("sentRevisedInvoiceMessage");
        }
      }]
    });
    modalInvoiceSent.closed.then(function (data) {
      $state.go('proposals', {uid: null});
    });
  }

  function openErrorInvoiceSentModal(error) {
    $scope.alertErrorFromServer(error);
  }

  function loadScopeToCreateInvoice($scope, proposalId, actionId){
    $scope.maxInvoiceLength = 500;
    $scope.remainingCharacters = $scope.maxInvoiceLength;
    $scope.invoiceText = "";

    if(actionId == "send-revised-invoice"){
      $http({
        url: configuration.webApi.invoices.getLastRejectedInvoice({ proposalId }),
        method: "GET"
      }).success(function (res, status, headers, config) {
        $scope.files = res.Attachments.map(function(a){
          var url = a.Key && a.Key.Url
          return {
            name: a.Name,
            url
          }
        })
  
        $scope.remainingCharacters = $scope.maxInvoiceLength - res.Note.length;
        $scope.invoiceText = res.Note;
      })
      .error(function (error, status, headers, config) {

      });
    }

    $scope.files = [];
    $scope.addedFiles = [];
    $scope.proposalId = proposalId;
    $scope.escrowFee = 0
    $scope.escrowTotal = 0

    $scope.acceptedFileFormats = ".zip,.jpg,.jpeg,.png,.gif,.pdf,.xls,.ppt,.doc,.docx";
    $scope.maxAttachmentFiles = 5;

    $scope.fileCountInvalid = function () {
      return $scope.addedFiles.length > 5;
    }

    $scope.removeFile = function (file) {
      $scope.files = $scope.files.filter(function (obj) { return obj.name != file.name });
    }

    $scope.updateCharactersLeft = function () {
      var invoiceLength = $scope.invoiceText ? $scope.invoiceText.length : 0;
      $scope.remainingCharacters = $scope.maxInvoiceLength - invoiceLength;
    }

    $scope.onSubtotalChange = function () {

      $scope.calculatingBill = true;
      $scope.invalidTotalMessage = '';
      var value = $scope.invoiceSubtotal;
      $scope.escrowFee = 0;
      $scope.escrowTotal = 0;
      if (isNaN(value) || value <= 0) {
        $scope.invalidTotalMessage = "The value should be a number greater than 0";
        $scope.calculatingBill = false;
      }
      else if (value >= 1000000000) {
        $scope.invalidTotalMessage = "Total too large";
        $scope.calculatingBill = false;
      }
      else {
        $http({
          url: configuration.webApi.invoices.calculateFee,
          method: "POST",
          data: value,
        }).success(function (res, status, headers, config) {
          $scope.calculatingBill = false;
          $scope.escrowFee = res.fees;
          $scope.escrowTotal = res.totalWithFee;
        }).error(function (error, status, headers, config) {
          $scope.calculatingBill = false;
          $scope.invalidTotalMessage = "Total too large";
        });
      }

    }
  }

  function loadScopeToShowInvoice($scope, proposalId, projectId){
    $http({
      url: configuration.webApi.invoices.getPendingInvoice({ projectId }),
      method: "GET"
    }).success(function (res, status, headers, config) {
      $scope.files = res.Attachments.map(function(a){
        var url = a.Key && a.Key.Url
        return {
          name: a.Name,
          url
        }
      })

      $scope.invoiceId = res.Id
      $scope.proposalId = proposalId;
      $scope.maxInvoiceLength = 500;
      $scope.remainingCharacters = $scope.maxInvoiceLength - res.Note.length;
      $scope.invoiceText = res.Note;
      $scope.escrowFee = res.TransactionFees;
      $scope.invoiceSubtotal = res.Total
      $scope.escrowTotal = res.TotalWithFee;
      $scope.acceptedFileFormats = ".zip,.jpg,.jpeg,.png,.gif,.pdf,.xls,.ppt,.doc,.docx";
      $scope.maxAttachmentFiles = 5;
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('proposals', {uid: null});
      })
    });
  }

  function openSendInvoiceModal(proposalId, actionId, projectId) {
    var modalSendInvoice = $uibModal.open({
      templateUrl: 'modal-' + actionId + '.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, $q, $state) {
        function init() {
          if(actionId == "resend-invoice"){
            loadScopeToShowInvoice($scope, proposalId, projectId);
          }
          else {
            loadScopeToCreateInvoice($scope, proposalId, actionId);
          }
        }

        $scope.submitInvoice = function () {
          if(actionId == "resend-invoice"){
            resendInvoice($scope.invoiceId, actionId)
          } else {
            openSendConfirmationModal($scope.proposalId, $scope.invoiceSubtotal, $scope.escrowFee, $scope.escrowTotal, $scope.invoiceText, $scope.files, actionId);
          }
        }

        init();
      }]
    });
    modalSendInvoice.closed.then(function (data) {
      $state.go('proposals', {uid: null});
    });
  }

  function resendInvoice(invoiceId, actionId) {
    $http({
      url: configuration.webApi.invoices.resendInvoice({
        id: invoiceId
      }),
      method: "POST"
    }).success(function (res, status, headers, config) {
      openInvoiceSentModal(actionId)
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('proposals', {uid: null});
      });
    });
  }

  function openSendConfirmationModal(proposalId, invoiceSubtotal, escrowFee, escrowTotal, invoiceText, files, actionId) {
    var modalSendInvoiceConfirmation = $uibModal.open({
      templateUrl: 'modal-' + actionId + '-confirmation.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, $q, $state, Upload) {
        function init() {
          $scope.files = files;
          $scope.isUploading = true;
          $scope.proposalId = proposalId;
          $scope.invoiceText = invoiceText;
          $scope.escrowFee = escrowFee;
          $scope.escrowTotal = escrowTotal;
          $scope.invoiceSubtotal = invoiceSubtotal;

          $scope.uploadPercentage = 0;
          $scope.isUploading = false;

          if (!invoiceSubtotal) {
            $scope.invoiceSubtotal = 0;
          }
          if (actionId == "send-invoice"){
            $scope.sendInvoiceMessageConfirmation = $scope.getMessagesParagraphs("sendInvoiceConfirmationMessage", "pe4hFeePercentage"); 
          }
          else if (actionId == "send-revised-invoice"){
            $scope.sendInvoiceMessageConfirmation = $scope.getMessagesParagraphs("sendRevisedInvoiceConfirmationMessage", "pe4hFeePercentage");       
          }
                   
        }

        $scope.submitInvoice = function () {
          $scope.isUploading = true;

          var upload = Upload.upload({
            url: configuration.webApi.invoices.sendInvoice({
              proposalId: $scope.proposalId
            }),
            data: {
              Total: $scope.invoiceSubtotal,
              NoteToClient: $scope.invoiceText,
              Attachments: $scope.files,
            }
          });

          upload.then(onSuccess, onError)

          upload.xhr(function (xhr) {
            xhr.upload.addEventListener('progress', function (data) {
              var percentage = (data.loaded / data.total) * 100;
              $scope.uploadPercentage = Math.round(percentage);
            })
          });

          function onSuccess(res, status, headers, config) {
            $scope.isUploading = false;
            openInvoiceSentModal(actionId);
          }

          function onError(error, status, headers, config) {
            $scope.isUploading = false;
            openErrorInvoiceSentModal(error);
          }
        };

        init();
      }]
    });
    modalSendInvoiceConfirmation.closed.then(function (data) {
    });
  }

  function openSendInvoiceModalWithMessage(proposalId, actionId) {

    $scope.sendInvoiceMessageBottom = $scope.getMessagesParagraphs("sendInvoiceMessageBottom", "pe4hFeePercentage");
    $scope.sendInvoiceMessageTop = $scope.getMessagesParagraphs("sendInvoiceMessageTop");
    $scope.sendInvoicePlaceholder = $scope.getMessageWithoutParagraphs("sendInvoicePlaceholder");

    openSendInvoiceModal(proposalId, actionId);
  }

  function openResendInvoiceWithMessage(proposalId, actionId, projectId){
    $scope.resendInvoiceMessageBottom = $scope.getMessagesParagraphs("resendInvoiceMessageBottom", "pe4hFeePercentage");
    $scope.resendInvoiceMessageTop = $scope.getMessagesParagraphs("resendInvoiceMessageTop");
    $scope.resendInvoicePlaceholder = $scope.getMessageWithoutParagraphs("resendInvoicePlaceholder");

    openSendInvoiceModal(proposalId, actionId, projectId);
  }

  function openSendRevisedInvoiceModalWithMessage(proposalId, actionId) {

    $scope.sendRevisedInvoiceMessageBottom = $scope.getMessagesParagraphs("sendRevisedInvoiceMessageBottom", "pe4hFeePercentage");
    $scope.sendRevisedInvoiceMessageTop = $scope.getMessagesParagraphs("sendRevisedInvoiceMessageTop");
    $scope.sendRevisedInvoicePlaceholder = $scope.getMessageWithoutParagraphs("sendRevisedInvoicePlaceholder");

    openSendInvoiceModal(proposalId, actionId);
  }

  function openRequestReleaseOfFundsModal(proposalId, actionId){
    var modalRequestReleaseOfFunds = $uibModal.open({
      templateUrl: 'modal-' + actionId + '.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, $q, $state, Upload) {
        $scope.confirmed = false;

        $scope.requestReleaseOfFunds = function(){
          if($scope.confirmed){
            sendRequestReleaseOfFunds(proposalId);
          }
        }
        if (actionId == "request-release-of-funds"){
          $scope.requestReleaseOfFundsMessage = $scope.getMessagesParagraphs("requestReleaseOfFundsMessage");
        }
        else if (actionId == "re-request-release-of-funds"){
          $scope.confirmed = true;
          $scope.requestReleaseOfFundsMessage = $scope.getMessagesParagraphs("reRequestReleaseOfFundsMessage");   
        }
        

        $scope.requestReleaseOfFunds = function(){
          sendRequestReleaseOfFunds(proposalId, actionId);
        }
      }]
    });
    modalRequestReleaseOfFunds.closed.then(function (data) {
      $state.go('proposals', {uid: null});
    });
  }

  function openRequestReleaseOfFundsSentModal(actionId){
    var modalRequestReleaseOfFunds = $uibModal.open({
      templateUrl: 'modal-' + actionId + '-sent.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, $q, $state, Upload) {
        if (actionId == "request-release-of-funds"){
          $scope.requestReleaseOfFundsSentMessage = $scope.getMessagesParagraphs("requestReleaseOfFundsSentMessage");
        }
        else if (actionId == "re-request-release-of-funds"){
          $scope.requestReleaseOfFundsSentMessage = $scope.getMessagesParagraphs("reRequestReleaseOfFundsSentMessage"); 
        }
        
      }]
    });
    modalRequestReleaseOfFunds.closed.then(function (data) {
      $state.go('proposals', {uid: null});
    });
  }

  function sendRequestReleaseOfFunds(proposalId, actionId){
    $http({
      url: configuration.webApi.proposals.request_release_of_funds({
        id: proposalId
      }),
      method: "POST",
    }).success(function (res, status, headers, config) {
      openRequestReleaseOfFundsSentModal(actionId);
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
    });
  }

  function init() {
    $scope.pageMode = 25;
    $scope.profileData = {};
    $scope.calculatingBill = false;

    // Paging
    $scope.paging = {};
    $scope.paging.values = [25, 100, Number.MAX_SAFE_INTEGER];
    $scope.paging.display = ["25", "100", "All"];
    $scope.paging.mode = $scope.paging.values[0];
    $scope.paging.current = 1;
  }

  init();
});
